export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const POST_LOADING = 'POST_LOADING';
export const POST_DATA = 'POST_DATA';
export const GET_ALL_DEALS = 'GET_ALL_DEALS';
export const FETCHING_ALL_DEALS = 'FETCHING_ALL_DEALS';

